const WORDS = ["Sell fast", "Buy first", "Deals with a deadline", "Phones", "Vehicles", "Watches", "Home", "Laptops", "Made for right now"];

const Row = ({ reverse, outline }) => (
  <div className="flex overflow-hidden">
    <div className={`marquee-track flex shrink-0 gap-10 pr-10 ${reverse ? "reverse" : ""}`}>
      {[...WORDS, ...WORDS].map((w, i) => (
        <span key={i} className={`flex items-center gap-10 whitespace-nowrap font-display text-4xl sm:text-6xl font-bold tracking-tight ${outline ? "text-zinc-500" : "text-zinc-100"}`}>
          {w}
          <span className="h-3 w-3 rotate-45 bg-[#FF3838]" />
        </span>
      ))}
    </div>
  </div>
);

export const Marquee = () => (
  <section className="relative border-y border-white/[0.08] py-10 space-y-4" data-testid="editorial-marquee" aria-label="Highlights">
    <Row />
    <Row reverse outline />
  </section>
);
